import { type ElementType, type ReactNode } from 'react';

import {
  Typography,
  type TypographyDefaultComponent,
  type TypographyProps,
} from '../typography/Typography';

export type UserNameTextPartialProps = {
  readonly firstName?: string;
  readonly fullName?: string;
  readonly lastName?: string;
};

export type UserNameTextProps<E extends ElementType = TypographyDefaultComponent> =
  TypographyProps<E> & UserNameTextPartialProps;

const parseName = (props: UserNameTextPartialProps): ReactNode => {
  if (props.fullName?.trim()) {
    return props.fullName.trim();
  } else if (props.firstName?.trim() && props.lastName?.trim()) {
    return `${props.firstName.trim()} ${props.lastName.trim()}`;
  } else if (props.firstName?.trim()) {
    return props.firstName.trim();
  } else if (props.lastName?.trim()) {
    return props.lastName.trim();
  }
  return null;
};

export const UserNameText = <E extends ElementType = TypographyDefaultComponent>({
  children,
  firstName,
  fullName,
  lastName,
  ...props
}: UserNameTextProps<E>) => {
  const content = parseName({ firstName, fullName, lastName }) || children;
  if (content) {
    return (
      <Typography<E>
        lineClamp={1}
        lineHeight='22px'
        variant='body2'
        {...(props as TypographyProps<E>)}
      >
        {content}
      </Typography>
    );
  }
  return null;
};
